import awaitWrap from '../../../../procedures/await-wrap';
import httpWrap from '../../../../procedures/http-wrap';
import router from '../../../../router';
import action from '../../../abstract/action';

const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {
      api: {
        softDelete,
      },
    },
  },
) => {
  $vs.dialog({
    accept: async () => await httpWrap({
      $vs,
      action: softDelete,
      success: { text: 'Deklaracja została usunięta' },
      onSuccess: async (res) => {

        if (Object.values(router.currentRoute?.query).find(v => v.includes('zusdeclarationspackages.id')) && res?._newPackage === null) {
          await router.push({
            path: '/zus/declarations',
          });
          return;
        }

        if (res?._newPackage && Object.values(router.currentRoute?.query).find(v => v.includes('zusdeclarationspackages.id'))) {
          await router.push({
            path: '/zus/declarations',
            query: {
              filters: JSON.stringify([
                {
                  field: 'zusdeclarationspackages.id',
                  value: res?._newPackage,
                },
              ]),
            },
          });
          return;
        }
        await awaitWrap(reloadList)();
      },
    })(item),
    type: 'confirm',
    color: 'primary',
    title: 'Usunięcie deklaracji',
    text: await awaitWrap(({ id }) => `Czy na pewno chcesz usunąć deklarację?`)(item),
    acceptText: 'Usuń',
    cancelText: 'Wróć',
  });
};

export default action({
  label: 'Usuń',
  icon: 'TrashIcon',
  main: () => false,
  handle,
  render: ({ item }) => item.zusdeclarationspackages === null || item.zusdeclarationspackages.status !== 'Przesyłka przyjęta do ZUS',
  disabled: (item) => isDisabled(item),
  tooltip: {
    isActive: (item) => isDisabled(item),
    text: 'Nie można edytować deklaracji przypisanej do zestawu lub wysłanej do urzędu',
  },
});

function isDisabled(item) {
  if (item?.zusdeclarationspackages?.sent_at === null) {
    return false;
  }

  return item?.zusdeclarationspackages?.status === 'Przesyłka przyjęta do ZUS' ||
    item?.zusdeclarationspackages?.status === 'Przesyłka przyjęta do kontroli' ||
    (item?.zusdeclarationspackages?.status === null && item?.zusdeclarationspackages?.sent_at !== null);
}
